import './css/App.css';
import ResetPassword from './pages/ResetPassword.js';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import ResetSuccess from './pages/ResetSucess.js';
import ResetExpired from './pages/ResetExpired.js';
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ResetPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/reset-expired" element={<ResetExpired />} />
          <Route path="/reset-sucess" element={<ResetSuccess />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;

